module.exports = "/_next/static/images/4871847d46d284a620264925998525a4-hero-small.jpg";